// extracted by mini-css-extract-plugin
export var caseStudy = "EventPage-module--caseStudy--7e8f8";
export var intro = "EventPage-module--intro--58282";
export var links = "EventPage-module--links--6ae54";
export var linksDescription = "EventPage-module--linksDescription--6ea44";
export var linksHeader = "EventPage-module--linksHeader--9a7d4";
export var linksList = "EventPage-module--linksList--ed3c6";
export var media = "EventPage-module--media--071f4";
export var mediaHeader = "EventPage-module--mediaHeader--8db05";
export var mediaIcon = "EventPage-module--mediaIcon--65e39";
export var moreEvents = "EventPage-module--moreEvents--dd606";
export var moreWork = "EventPage-module--moreWork--69d89";
export var withAttend = "EventPage-module--withAttend--b0f10";